import Link from "next/link";
import Srcset from "@/components/common/Srcset";
import styles from "../Footer.module.scss";
import { generalConstants } from "@/utils/constants";

export default function ContactLinks() {
  return (
    <>
      <div className={`grid-xs-12 grid-md-3 grid-sm-3 p-none`}>
        <div className="wrapper">
          <div className={styles.title_wrapper}>
            <div className={styles.mobile_wrapper}>
              <div className="row">
                <div className="grid-xs-5">
                  <p className={`normal-md x-small-sm small-xs bold ${styles.customer_care}`}
                    >
                    Contact
                  </p>
                  <div
                    className={`d-md-none xx-small-sm ${styles.mobile_text}`}
                  >
                    <span className={`xx-small ${styles.icon} ${styles.left}`}>
                      M-F 8am - 4pm EST
                    </span>
                  </div>
                </div>
                <div className={`grid-xs-7 d-md-none ${styles.phone_icon}`}>
                  <div className="row">
                     {/* <div className="grid-xs-6 d-md-none">
                      <div className={`d-md-none ${styles.phone_icon_btn}`}>
                        <Link className={`${styles.icon} ga_footer_link_text`} tabIndex={0} href="tel:+18554542978">
                            <Srcset
                              height="16"
                              width="16"
                              src={"images/Icons/Phone.svg"}
                              alt="phone"
                              requirePath={true}
                              svgFile={true}
                              lazyLoad={true}
                            />
                            <span className={`xx-small`}>Phone</span>
                        </Link>
                      </div>
                    </div> */}
                    <div className={`grid-xs-6 d-md-none ${styles.email_icon}`}>
                      <div className="d-md-none">
                        <Link className={`${styles.icon} ga_footer_link_text ${styles.mobile_email_second}`} tabIndex={0} href={`mailto:${generalConstants.help_email}`}>
                            <Srcset
                              height="16"
                              width="18"
                              src={"images/Icons/Email.svg"}
                              alt="email"
                              requirePath={true}
                              svgFile={true}
                              lazyLoad={true}
                            />
                            <span className={`xx-small`}>Email</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* <div className="grid-xs-12 d-md-none">
                      <div className={`d-md-none ${styles.whatsapp_icon}`}>
                        <Link className={`${styles.icon} ga_footer_link_text`} tabIndex={0} href="https://wa.me/19174392940" target="_blank">
                            <Srcset
                                height="16"
                                width="16"
                                src={"images/Icons/Whatsapp_dark.png"}
                                alt="whatsapp_no"
                                requirePath={true}
                                svgFile={true}
                                lazyLoad={true}
                            />
                            <span className={`xx-small`}>Whatsapp</span>
                        </Link>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ul>
            <li className={`d-xs-none ${styles.item}`}>
              <p className={`x-small-md xx-small-sm ${styles.normal} ga_footer_link_text ${styles.margin_bottom_inline}`}
              >
                M-F 8am - 4pm EST
              </p>
            </li>
            {/* <li className={`d-xs-none ${styles.item}`}>
              <a href="tel:+18554542978" className={`x-small-md xx-small-sm ${styles.normal} ${styles.margin_top} ga_footer_link_text auto-phone-care`}>
              1-855-454-2978
              </a>
            </li> */}
            <li className={`d-xs-none ${styles.item}`}>
              <Link className={`x-small-md xx-small-sm ${styles.border_bottom} ${styles.normal} ga_footer_link_text auto-email-care`} tabIndex={0} href={`mailto:${generalConstants.help_email}`}>
                Email customer care
              </Link>
            </li>
            {/* <li className={`d-xs-none ${styles.item}`}>
              <a href="https://wa.me/19174392940" target="_blank" className={`x-small-md xx-small-sm ${styles.normal} ${styles.margin_top} ga_footer_link_text auto-stylist-care`}>
              Whatsapp / Text Stylist team: 917-439-2940
              </a>
            </li> */}
          </ul>
        </div>
      </div>

      {/* <div className="grid-xs-12 grid-md-3 grid-sm-3 p-none">&nbsp;</div> */}
    </>
  );
}